$(function(){

    const $EucPlusVideoModal = $('#EucPlusModalVideo');
    const $EucPlusvideoFrame = $('#EucPlusModalVideoFrame');
    const $EucPlusvideoSrc = $EucPlusvideoFrame.attr('src');

    $EucPlusVideoModal.on('hidden.bs.modal', function(){
        // when modal hides, turn off the video
        $EucPlusvideoFrame.attr('src', $EucPlusvideoSrc);
    });
});